import { render, staticRenderFns } from "./ChatbotDashboard.vue?vue&type=template&id=75aedaa1&scoped=true"
import script from "./ChatbotDashboard.vue?vue&type=script&lang=js"
export * from "./ChatbotDashboard.vue?vue&type=script&lang=js"
import style0 from "./ChatbotDashboard.vue?vue&type=style&index=0&id=75aedaa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aedaa1",
  null
  
)

export default component.exports